import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/auth',
    name: 'Auth',
    component: () => import('../views/Auth.vue')
  },
  {
    path: '/result',
    name: 'result',
    component: () => import('../views/ResultView.vue')
  },
  {
    path: '/wrong',
    name: 'wrong',
    component: () => import('../views/ListView.vue')
  },
  {
    path: '/bookmark',
    name: 'bookmark',
    component: () => import('../views/ListView.vue')
  },
  {
    path: '/category',
    name: 'category',
    component: () => import('../views/CategoryView.vue')
  },
  {
    path: '/howtouse',
    name: 'howtouse',
    component: () => import('../views/Howtouse.vue')
  },
  {
    path: '/exam/:index',
    name: 'exam',
    component: () => import('../views/ShiwakeView.vue')
  },
  {
    path: '/category/:categoryId/:index',
    name: 'shiwake',
    component: () => import('../views/ShiwakeView.vue')
  },
  {
    path: '/shiwake/q/:index',
    name: 'shiwakeFromId',
    component: () => import('../views/ShiwakeView.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
